export default {"src":"/_next/static/media/instagram.e91c3dab.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};